import React, { useState, useRef } from 'react';
import { Input } from '@idexio/dev-idex-swap-uikit';
import styled from 'styled-components/macro';

const StyledInput = styled(Input)`
  margin-left: auto;
`;

const InputWrapper = styled.div`
  position: relative;
  ${({ theme }) => theme.mediaQueries.sm} {
    width: 234px;
    display: block;
  }
`;

const Container = styled.div<{ toggled: boolean }>``;

interface Props {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const SearchInput: React.FC<Props> = ({ value, onChange }) => {
  const [toggled, setToggled] = useState(false);
  const inputEl = useRef(null);

  return (
    <Container toggled={toggled}>
      <InputWrapper>
        <StyledInput
          ref={inputEl}
          value={value}
          onChange={onChange}
          placeholder="Search farms"
          onBlur={() => setToggled(false)}
          scale="lg"
        />
      </InputWrapper>
    </Container>
  );
};

export default SearchInput;
